import React from 'react'

function TabPanel(props) {
	const { children, value, index, noMarginTop, ...other } = props

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`vertical-tabpanel-${index}`}
			aria-labelledby={`vertical-tab-${index}`}
			{...other}
		>
			{value === index && (
				<div className={noMarginTop ? '' : 'mt-5'}>{children}</div>
			)}
		</div>
	)
}

export default TabPanel
